import ActivatePaidServicesModal from './ActivatePaidServicesModal';

export default ActivatePaidServicesModal;
